<template>
    <modal v-model:show="showModal" :showClose="false" :clickClose="false">
        <template v-slot:header>
            <div class="d-flex justify-content-between align-items-center w-100">
                <h5 class="modal-title mb-0">
                    Exit Details
                </h5>
                <button class="btn btn-link p-0" @click="closeModal">
                    <i class="fas fa-times"></i>
                </button>
            </div>
        </template>
        <div>
            <div v-for="(item, index) in exitDetails" :key="index" class="small">
                <div><b>{{ formatPortfolioName(item.portfolioName) }}</b></div>
                <div><b>Status :</b> {{ item.executedStatus }}</div>
                <div><b>Exit Type :</b> {{ item.exitType }}</div>
                <div v-if="item.brokerOrderRemarks">
                    <b>Remark :</b> {{ item.brokerOrderRemarks }}
                </div>
                <div class="text-muted">
                    {{ formatDateTime(item.executedDateTime) }}
                </div>
                <hr v-if="index !== exitDetails.length - 1" />
            </div>
        </div>
    </modal>
</template>
<script>
import Modal from "@/components/Modal";
export default {
    components: {
        Modal,
    },
    props: {
        showModal: {
            type: Boolean,
            default: false,
        },
        exitDetails: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            isPlaying: false,
            positons: [],

        }
    },
    methods: {
        closeModal() {
            this.$emit('updateParameters', false);
        },
        formatPortfolioName(name) {
            return name
                .split('_')
                .map(word => {
                    return /^[a-zA-Z]+$/.test(word)
                        ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                        : word;
                })
                .join(' ');
        },
        formatDateTime(dateTime) {
            if (!dateTime) return "";
            return new Date(dateTime).toLocaleString();
        }
    },
};
</script>
